export type NotificationType = "ERROR" | "SUCCESS" | "INFO" | "WARNING" | "NOTICE";
export type NotificationValueType = "error" | "success" | "info" | "warning";

export const NOTIFICATION_HEADERS: Record<NotificationType, string> = {
  ERROR: "Ошибка",
  SUCCESS: "Успешно",
  INFO: "Информация",
  WARNING: "Предупреждение",
  NOTICE: "Уведомление",
};

export const NOTIFICATION_TYPES: Record<NotificationType, NotificationValueType> = {
  ERROR: "error",
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  NOTICE: "info",
};

export const NOTIFICATION_TYPE_ENUM: Record<NotificationType, NotificationType> = {
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
  INFO: "INFO",
  WARNING: "WARNING",
  NOTICE: "NOTICE",
};
